<!--  
<template functional>
  <div
  class="input-field input-field-container"
  :class="{
    'border-bottom': props.config.borderStyle == 'bottom',
    'border-around': props.config.borderStyle == 'around',
    'border-none': props.config.borderStyle == 'none',
  }"
  >
    <input
      :value="props.value" 
      :type="props.type" 
      class="dbox-form--input v2"
      :placeholder="props.placeholder"
      :name="props.id" 
      :id="props.id"
      v-on:blur="listeners.blur || (() => {})"
      @keyup="listeners.keyup"
    />
    <div class="input-icon" v-if="!props.config.noicon">
      <img src="static/icons/lupe.svg" alt="">
    </div>
  </div>
</template> 

-->

<script>
const noop = () => {};

export default {
  functional: true,
  props: [
    "config",
    "value",
    "type",
    "placeholder",
    "id",
    "name",
    "disabled",
  ],

  render: function (h, context) {
    const { props, listeners } = context;
    const onBlur = listeners.blur || noop;
    const onKeyup = listeners.keyup || noop;

    return h(
      "div",
      {
        class: {
          "input-field-container": true,
          "border-bottom": props.config.borderStyle == "bottom",
          "border-around": props.config.borderStyle == "around",
          "border-none": props.config.borderStyle == "none",
        },
        style: {
          width: props.config.width || "auto",
          maxWidth:
            props.config.maxWidth ||"115px",
          minWidth:
            props.config.minWidth ||"115px",
        },
      },
      [
        h("input", {
          domProps: {
            value: props.value,
            placeholder: props.placeholder,
          },
          attrs: {
            type: props.type,
            name: props.name,
            id: props.id,
            disabled: props.disabled,
          },
          class: {
            "dbox-form--input v2": true,
          },
          on: {
            blur: onBlur,
            keyup: onKeyup,
          },
        }),
        !props.config.noicon
          ? h(
              "div",
              {
                staticClass: "input-icon dt-icon-container",
              },
              [
                h("img", {
                  attrs: {
                    src: "static/icons/lupe.svg",
                  },
                }),
              ]
            )
          : undefined,
      ]
    );
  },
};
</script>


<style lang="scss" scoped>
.input-field-container {
  display: flex;
  border-color: var(--sprt-5);
  height: 30px;
  border-bottom: 1px solid;
  position: relative;

  .dbox-form--input {
    // width: 100%;
  }
  .input-icon {
    position: absolute;
    right: 0px;
  }

  &.border-bottom {
    border-bottom: 1px solid var(--sprt-5);
  }
  &.border-around {
    border: 1px solid var(--sprt-5);
    border-radius: 3px;
    padding: 0px 10px;
  }
  &.border-none {
    border-color: transparent;
  }
}
</style>
